
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39 0H9C4.028 0 0 4.028 0 9v30c0 4.972 4.028 9 9 9h30c4.972 0 9-4.028 9-9V9c0-4.972-4.028-9-9-9zm-1.22 25.85h-4.492v16.623h-7.5V25.85h-2.91v-5.6h2.91v-3.566c0-4.677 1.943-7.453 7.454-7.453h5.585v5.579h-3.244c-2.145 0-2.286.8-2.286 2.295l-.009 3.144h5.103l-.611 5.6z","fill":"#FF671B"}})])
          )
        }
      }
    